export enum EAnalyticsApiUrl {
  transactionReports = '/api/analytics/reports/tasks',
}
